import {ConfigService} from '@services/./configService';
import {environment} from '../../environments/environment';

export function ConfigLoader(configService: ConfigService) {
    return () => configService.load(environment.configFile);
}
